import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { getCurrentAccount } from '../account_helpers';
import DefaultError from '../errors/defaultError';

type GraphError = {
  message: string;
  type?: string;
};

export class FetchError extends Error {
  public type: string | boolean = false;
  constructor(error: GraphError) {
    super(error.message); // (1)
    this.type = error?.type || false; // (2)
  }
}

export function readCookie(name: string) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

async function fetchQuery(operation: any, variables: any) {
  const CSRF_TOKEN = readCookie('csrf');

  const headers: any = {
    'content-type': 'application/json',
    'X-CSRF-TOKEN': CSRF_TOKEN,
    'X-ACCOUNT-ID': getCurrentAccount(),
  };

  let resp: any;
  let json: any;
  try {
    resp = await fetch(`${process.env.REACT_APP_API_URL}/graphql`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        query: operation.text,
        variables,
      }),
      credentials: 'include',
    });
  } catch {
    throw new DefaultError({
      message: 'Unable to fetch from server',
      title: 'Unable to contact PayPI server',
      helpText: 'Please check your internet connection and try again.',
    });
  }

  try {
    json = await resp.json();
  } catch {
    throw new DefaultError({
      message: 'Unable to fetch from server',
      title: 'Invalid response recieved from PayPI server',
      helpText: 'Please try again and contact support if the problem persists.',
    });
  }

  if (json && 'errors' in json) {
    for (const err of json.errors) {
      switch (err.extensions?.type) {
        case 'ErrUserNotAuthenticated':
          throw new DefaultError({
            message: 'User not authenticated',
            title: 'User not authenticated',
            helpText: 'Please check you are logged in and try again.',
          });

        case 'ErrWhileHandling':
          throw new DefaultError({
            message: 'Unknown error while handling',
            title: 'An error occurred while handling your request',
            helpText: 'Please check your request and try again.',
          });

        case 'ErrUnauthorized':
          throw new DefaultError({
            message: 'Unauthorized from server',
            title: 'Unauthorized to perform this operation',
            helpText: 'Please check you are logged in and try again.',
          });

        case 'ErrUnableToResolve':
          throw new DefaultError({
            message: 'Server error',
            title: 'Server error',
            helpText: 'Please contact support for assistance',
          });

        default:
          throw new DefaultError({
            message: err.extensions?.message,
            title: err.extensions?.type ?? 'An error occured',
            helpText:
              err.extensions?.helpText ??
              'Please reload the page and try again.',
          });
      }
    }
  }
  return json;
}

export default new Environment({
  network: Network.create(fetchQuery),
  store: new Store(new RecordSource()),
});
